import React from 'react';
import { Entry } from '../../types';

interface VoteButtonProps {
    entry: Entry;
}
export const VoteButton: React.FC<VoteButtonProps> = ({ entry }) => {
    return (
        <div className="has-text-centered is-margin-bottom-1">
            <a className="button is-fullwidth is-gorgeous is-medium" href={`${process.env.REACT_APP_VOTE_NEW_URL}/${entry.entry_id}`}>
                <span>WEB投票</span>
            </a>
        </div>
    );
};